import { useCallback } from 'react';

export const useCountCodes = () => {
  const countCodesInCsv = useCallback(async (file: File): Promise<number> => {
    try {
      const text = await file.text();
      const lines = text
        .split(/\r?\n/)
        .map(l => l.trim())
        .filter(Boolean);

      if (lines.length === 0) return 0;

      const header = lines[0].replace(/^\uFEFF/, '');
      const startIndex = /^code$/i.test(header) ? 1 : 0;

      return lines.slice(startIndex).length;
    } catch {
      return 0;
    }
  }, []);

  return { countCodesInCsv };
};
